import { Maybe } from 't2-graphql-types';

export const getPromptEditPageUrl = (promptSlug?: Maybe<string>): string => `/prompt/${promptSlug}/edit`;
